import React from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import App2 from "./App";
import Email from "./Email";
import ProdottiOnline from "./ProdottiOnline";
import "./App.css";
import NuovoPorgetto from "./NuovoPorgetto";

export default function App() {
  return (
    <Router>
      <div>
        <nav className="header">
          <ul>
            <li>
              <Link to="/">Publica</Link>
            </li>
            <li>
              <Link to="/email">Email</Link>
            </li>
            <li>
              <Link to="/prodotti">Prodotti</Link>
            </li>
            <li>
              <Link to="/progetto">Nuovo progetto</Link>
            </li>
          </ul>
        </nav>

        {/* A <Switch> looks through its children <Route>s and
              renders the first one that matches the current URL. */}
        <Switch>
          <Route exact path="/email">
            <Email />
          </Route>

          <Route exact path="/">
            <App2></App2>
          </Route>

          <Route exact path="/Prodotti">
            <ProdottiOnline />
          </Route>

          <Route exact path="/Progetto">
            <NuovoPorgetto/>
          </Route>
        </Switch>
      </div>
    </Router>
  );
}
